/**
 * Drawing label taxonomy for Mapping Check UI.
 * AUTO-GENERATED — do not edit by hand.
 * Regenerate: node scripts/generate-drawing-taxonomy.mjs
 */

export const REFERENCE_ANNOTATION_GROUPS = {
  "tags_labels": [
    "room tag",
    "space tag",
    "area tag",
    "door tag",
    "window tag",
    "curtain wall panel tag",
    "wall type tag",
    "wall tag",
    "floor tag",
    "ceiling tag",
    "roof tag",
    "stair tag",
    "railing tag",
    "furniture tag",
    "equipment tag",
    "mechanical equipment tag",
    "plumbing fixture tag",
    "light fixture tag",
    "receptacle tag",
    "switch tag",
    "panel tag",
    "transformer tag",
    "motor tag",
    "diffuser tag",
    "grille tag",
    "duct tag",
    "pipe tag",
    "valve tag",
    "sprinkler head tag",
    "standpipe tag",
    "fire alarm device tag",
    "smoke detector tag",
    "structural column tag",
    "structural beam tag",
    "structural brace tag",
    "foundation tag",
    "pile tag",
    "connection tag",
    "rebar tag",
    "anchor tag",
    "material tag",
    "assembly tag",
    "finish tag",
    "keynote tag",
    "revision tag",
    "issue tag",
    "occupancy tag",
    "parking stall tag",
    "site furnishing tag",
    "tree tag",
    "plant tag",
    "fence tag",
    "bollard tag",
    "manhole tag",
    "catch basin tag",
    "inlet tag",
    "utility pole tag",
    "elevator tag",
    "escalator tag",
    "signage tag",
    "accessibility symbol tag",
    "phase tag",
    "demolition tag",
    "new work tag",
    "existing to remain tag",
    "NIC tag",
    "by others tag",
    "TBD tag",
    "placeholder tag"
  ],
  "legends_keys": [
    "keynote legend",
    "symbol legend",
    "abbreviation legend",
    "linetype legend",
    "line weight legend",
    "hatch pattern legend",
    "material legend",
    "finish legend",
    "door type legend",
    "window type legend",
    "wall type legend",
    "roof type legend",
    "ceiling type legend",
    "floor finish legend",
    "plumbing fixture legend",
    "mechanical equipment legend",
    "electrical device legend",
    "lighting fixture legend",
    "fire protection legend",
    "life safety legend",
    "structural steel legend",
    "concrete legend",
    "masonry legend",
    "site legend",
    "grading legend",
    "paving legend",
    "landscape legend",
    "demolition legend",
    "phasing legend",
    "accessibility legend",
    "signage type legend",
    "panel type legend",
    "valve type legend",
    "sprinkler type legend",
    "diffuser type legend",
    "contour interval legend",
    "utility legend",
    "survey legend"
  ],
  "callouts_view_references": [
    "detail callout",
    "section callout",
    "elevation callout",
    "plan callout",
    "enlarged plan callout",
    "interior elevation callout",
    "wall section callout",
    "stair section callout",
    "roof plan callout",
    "reflected ceiling plan callout",
    "isometric callout",
    "axonometric callout",
    "perspective callout",
    "diagram callout",
    "schematic callout",
    "reference bubble",
    "view reference bubble",
    "sheet reference bubble",
    "detail reference",
    "see detail",
    "see section",
    "see elevation",
    "see enlarged plan",
    "see reflected ceiling plan",
    "see schedule",
    "see specification section",
    "see diagram",
    "see riser diagram",
    "see one-line diagram",
    "see site plan",
    "see floor plan",
    "see roof plan",
    "interior perspective reference",
    "3D view reference",
    "clash snapshot reference",
    "rendering reference",
    "photo reference inset"
  ],
  "section_markers": [
    "building section marker",
    "wall section marker",
    "partial section marker",
    "stair section marker",
    "roof section marker",
    "site section marker",
    "section arrow head",
    "section tail",
    "section cut line",
    "section reference number",
    "keyed section marker",
    "wall type section marker",
    "assembly section marker",
    "MEP section marker",
    "structural section marker",
    "fire-rated assembly section marker",
    "interior partition section marker",
    "foundation section marker",
    "envelope section marker",
    "detail section marker"
  ],
  "elevation_markers": [
    "exterior elevation marker",
    "interior elevation marker",
    "building elevation marker",
    "elevation tag",
    "elevation direction arrow",
    "elevation reference bubble",
    "roof plan elevation indicator",
    "facade elevation marker",
    "curtain wall elevation marker",
    "stair elevation marker",
    "millwork elevation marker",
    "signage elevation marker",
    "site elevation marker",
    "retaining wall elevation marker",
    "utility elevation marker"
  ],
  "levels_datums_grids": [
    "level head",
    "level symbol",
    "level annotation",
    "datum head",
    "datum note",
    "benchmark symbol",
    "survey benchmark callout",
    "grid head",
    "grid bubble",
    "column grid label",
    "structural grid label",
    "finish floor level marker",
    "top of steel marker",
    "top of concrete marker",
    "top of deck marker",
    "underside of deck marker",
    "invert level marker",
    "rim level marker",
    "property corner monument",
    "control point symbol",
    "project base point note",
    "survey base point note",
    "true north to project north note",
    "reference plane tag",
    "work plane tag",
    "scope box label",
    "building line label",
    "property line label",
    "setback line label",
    "easement label",
    "right-of-way label"
  ],
  "leaders_text_notes": [
    "leader note",
    "keynote leader",
    "material callout leader",
    "specification note leader",
    "general note",
    "flag note",
    "boxed note",
    "reference note",
    "coordination note leader",
    "field verify note",
    "typical note",
    "see structural note",
    "see MEP note",
    "means and methods note",
    "warranty note",
    "installation note",
    "sequence note",
    "phasing note",
    "safety note",
    "accessibility note",
    "code compliance note",
    "energy note",
    "acoustic note",
    "fire rating note leader",
    "penetration note",
    "firestopping note",
    "waterproofing note",
    "air barrier continuity note"
  ],
  "sheet_title_graphics": [
    "view title",
    "sheet title",
    "sheet number",
    "drawing number",
    "detail number",
    "scale notation",
    "not to scale flag",
    "north arrow",
    "graphic scale",
    "bar scale",
    "title block",
    "sheet border",
    "company logo block",
    "revision block",
    "issue date block",
    "profession seal",
    "discipline designation block",
    "sheet index entry",
    "drawing index entry",
    "LOD note",
    "workset responsibility note",
    "model link note",
    "file name reference",
    "shared coordinates note"
  ],
  "revision_graphics": [
    "revision cloud",
    "revision triangle",
    "revision delta",
    "issue cloud",
    "as-built markup",
    "record drawing markup",
    "delta markup",
    "sketch markup",
    "redline markup",
    "clouded area note"
  ],
  "schedules_on_sheet": [
    "door schedule on sheet",
    "window schedule on sheet",
    "finish schedule on sheet",
    "hardware schedule on sheet",
    "room finish schedule on sheet",
    "equipment schedule on sheet",
    "fixture schedule on sheet",
    "panel schedule on sheet",
    "load schedule on sheet",
    "diffuser schedule on sheet",
    "sprinkler schedule on sheet",
    "valve schedule on sheet",
    "manhole schedule on sheet",
    "signage schedule on sheet",
    "BAS points list on sheet",
    "I O schedule on sheet",
    "room data sheet on sheet",
    "keyed schedule reference"
  ],
  "identification_marks": [
    "piece mark",
    "erection mark",
    "shipping mark",
    "shop drawing mark",
    "panel mark",
    "module ID",
    "assembly mark",
    "weld mark",
    "bolt mark",
    "connection mark",
    "precast panel mark",
    "tilt-up panel mark",
    "curtain wall unit mark",
    "prefab module mark",
    "duct section mark",
    "pipe spool mark",
    "valve tag number",
    "equipment tag number",
    "circuit ID",
    "panel designation",
    "room number",
    "door number",
    "window type mark",
    "finish code mark",
    "key plan zone mark"
  ],
  "mep_schematic_graphics": [
    "one-line reference bubble",
    "riser diagram callout",
    "schematic flow arrow",
    "system abbreviation tag",
    "duct system tag",
    "piping system tag",
    "electrical circuit tag",
    "panel schedule tie-in",
    "BAS point tag",
    "control diagram reference",
    "sequence of operation reference",
    "hydraulic diagram reference",
    "airflow diagram reference",
    "plumbing isometric reference",
    "duct isometric reference",
    "equipment connection diagram",
    "single line diagram reference",
    "ladder diagram reference"
  ],
  "fire_life_safety_graphics": [
    "exit sign symbol",
    "egress path arrow",
    "fire rating tag",
    "fire barrier tag",
    "smoke barrier tag",
    "smoke compartment tag",
    "occupant load placard",
    "travel distance annotation",
    "common path annotation",
    "exit width annotation graphic",
    "stair identification sign",
    "area of refuge sign",
    "fire extinguisher location tag",
    "hose cabinet tag",
    "standpipe connection tag",
    "fire damper tag",
    "smoke damper tag",
    "fire door tag",
    "rated wall tag",
    "rated floor ceiling tag",
    "draft curtain tag",
    "fire command center sign"
  ],
  "site_civil_annotations": [
    "station equation",
    "alignment station label",
    "PI station label",
    "curve data callout",
    "property corner label",
    "bearing distance callout",
    "contour label",
    "spot grade callout graphic",
    "invert label",
    "rim label",
    "pipe size label on plan",
    "utility line label",
    "easement graphic",
    "wetland boundary label",
    "erosion control note",
    "SWPPP reference",
    "grading limit line",
    "cut fill limit label",
    "pavement marking legend",
    "striping legend",
    "traffic sign legend",
    "parking stall stripe",
    "accessible stall symbol",
    "loading zone label",
    "fire lane label",
    "tree protection zone",
    "silt fence line",
    "detention basin label"
  ],
  "accessibility_annotations": [
    "accessibility symbol",
    "accessible route arrow",
    "turning radius diagram",
    "clear floor space diagram",
    "grab bar elevation reference",
    "toilet clearance diagram",
    "door maneuvering clearance diagram",
    "ramp slope diagram",
    "handrail extension note",
    "detectable warning note",
    "accessible parking symbol",
    "accessible entrance symbol",
    "TDD symbol",
    "hearing loop symbol",
    "visual alarm symbol"
  ],
  "graphic_presentation_marks": [
    "matchline",
    "break line",
    "scope box",
    "crop region",
    "detail boundary",
    "halftone region",
    "diagram boundary",
    "phantom line note",
    "hidden line note",
    "work plane graphic",
    "section box graphic",
    "view range graphic",
    "underlay ghost graphic",
    "color-fill legend tie-in",
    "hatch direction note",
    "pattern scale note",
    "line style override note",
    "workset tint legend",
    "phase graphic override",
    "demolition graphic style",
    "new work graphic style"
  ],
  "coordination_references": [
    "RFI reference",
    "submittal reference",
    "shop drawing reference",
    "field verify flag",
    "NIC flag",
    "by others flag",
    "TBD flag",
    "placeholder flag",
    "coordination matrix reference",
    "clash report reference",
    "BIM issue reference",
    "Navisworks viewpoint reference",
    "design intent reference",
    "basis of design reference",
    "OPR reference",
    "code section reference graphic",
    "specification section reference graphic",
    "UL assembly listing reference graphic",
    "test report reference",
    "commissioning document reference"
  ]
};

export const REFERENCE_ANNOTATION_GROUP_LABELS = {
  "tags_labels": "Tags & element labels",
  "legends_keys": "Legends & keys",
  "callouts_view_references": "Callouts & view references",
  "section_markers": "Section markers & cut graphics",
  "elevation_markers": "Elevation markers",
  "levels_datums_grids": "Levels, datums & grids",
  "leaders_text_notes": "Leaders & text notes",
  "sheet_title_graphics": "Sheet, title block & scale graphics",
  "revision_graphics": "Revision & markup graphics",
  "schedules_on_sheet": "Schedules on sheet",
  "identification_marks": "Identification & numbering marks",
  "mep_schematic_graphics": "MEP schematic & diagram references",
  "fire_life_safety_graphics": "Fire & life safety graphics",
  "site_civil_annotations": "Site & civil annotations",
  "accessibility_annotations": "Accessibility graphics",
  "graphic_presentation_marks": "Graphic presentation marks",
  "coordination_references": "Coordination & document references"
};

export const DIMENSIONAL_OUTPUT_GROUPS = {
  "linear_dimensions": [
    "aligned dimension",
    "linear dimension",
    "overall length",
    "overall width",
    "running dimension",
    "continuous dimension",
    "baseline dimension",
    "chain dimension",
    "ordinate dimension",
    "opening width",
    "opening height",
    "rough opening width",
    "rough opening height",
    "clear opening width",
    "clear opening height",
    "span",
    "bay spacing",
    "module spacing",
    "on-center spacing",
    "repetitive spacing",
    "edge distance",
    "end distance",
    "lap length",
    "splice length",
    "development length",
    "development length rebar",
    "bar spacing dimension",
    "mesh spacing dimension",
    "arc length",
    "radius",
    "diameter",
    "chord length",
    "perimeter linear",
    "cut length",
    "stock length",
    "weld length",
    "seam length",
    "joint spacing",
    "true length vs projected length",
    "minimum dimension string",
    "maximum dimension string"
  ],
  "spot_instrument_dimensions": [
    "spot elevation",
    "spot slope",
    "spot coordinate",
    "spot easting northing",
    "relative elevation",
    "survey elevation",
    "level relative to datum",
    "slope arrow",
    "spot grade",
    "invert spot",
    "rim spot"
  ],
  "offsets_alignments": [
    "offset from grid",
    "offset from grid line",
    "offset from baseline",
    "offset from building line",
    "offset from property line",
    "offset from right-of-way",
    "offset from easement",
    "offset from column centerline",
    "offset from wall centerline",
    "offset from finish face",
    "offset from structure face",
    "offset from core",
    "offset from centerline",
    "inset",
    "setback",
    "setback from ROW",
    "reveal width",
    "throat dimension",
    "eccentricity",
    "in-plane offset",
    "out-of-plane offset",
    "parallel offset",
    "normal distance",
    "minimum clearance",
    "maximum span",
    "work point offset",
    "bearing offset",
    "maneuvering clearance",
    "door swing clearance",
    "pocket door pocket depth"
  ],
  "vertical_elevation": [
    "elevation",
    "finished floor elevation",
    "structural top of steel",
    "top of concrete",
    "top of deck",
    "underside of deck",
    "top of wall",
    "bottom of wall",
    "top of footing",
    "bottom of footing",
    "invert elevation",
    "rim elevation",
    "sill elevation",
    "head elevation",
    "parapet elevation",
    "roof elevation",
    "grade elevation",
    "benchmark elevation",
    "datum elevation",
    "story height",
    "floor-to-floor height",
    "clear height",
    "headroom",
    "ceiling elevation",
    "reflected ceiling plane elevation",
    "soffit elevation",
    "riser height",
    "tread depth",
    "going dimension",
    "nosing projection",
    "vertical rise",
    "total rise",
    "drop",
    "step height",
    "platform elevation",
    "pit depth",
    "trench depth",
    "cover depth below grade",
    "top of wall framing",
    "top of blocking"
  ],
  "depths_thicknesses": [
    "slab thickness",
    "topping thickness",
    "membrane thickness",
    "insulation thickness",
    "total wall assembly thickness",
    "air cavity depth",
    "gypsum layer thickness",
    "sheathing thickness",
    "cladding thickness",
    "veneer thickness",
    "coating thickness",
    "laminated build-up thickness",
    "cover concrete",
    "cover to reinforcement",
    "embed depth",
    "penetration depth",
    "anchor embedment",
    "sleeve length through wall",
    "stud leg length",
    "flange thickness",
    "web thickness",
    "plate thickness",
    "gauge",
    "kerf depth",
    "rabbet depth",
    "reveal depth",
    "groove depth",
    "counterbore depth",
    "countersink depth",
    "drainage mat thickness",
    "waterproofing build-up thickness",
    "pavement structure layer thickness",
    "subbase thickness"
  ],
  "sections_cuts": [
    "section cut depth",
    "section reference",
    "building section cut line",
    "partial section",
    "detail cut scope",
    "view depth",
    "far clip offset",
    "near clip offset",
    "crop region",
    "callout extent",
    "scope of demolition",
    "scope of new work",
    "work plane offset",
    "split line offset",
    "break line offset",
    "matchline offset",
    "detail boundary extent"
  ],
  "angles_slopes": [
    "angle",
    "included angle",
    "slope ratio",
    "percent slope",
    "cross slope",
    "longitudinal slope",
    "pitch",
    "rake angle",
    "bevel angle",
    "miter angle",
    "bearing angle",
    "azimuth",
    "deflection angle",
    "camber",
    "sweep angle",
    "rotation",
    "skew",
    "plumb tolerance",
    "level tolerance",
    "pipe slope percent",
    "duct slope percent"
  ],
  "areas_volumes": [
    "area gross",
    "area net",
    "rentable area",
    "usable area",
    "surface area",
    "floor area",
    "wall area",
    "roof area",
    "opening area",
    "glazing area",
    "glazing ratio",
    "volume",
    "excavation volume",
    "fill volume",
    "concrete volume",
    "formwork area",
    "paint area",
    "waterproofing area",
    "insulation board feet",
    "tonnage steel",
    "concrete yardage",
    "occupant load area basis",
    "catchment area",
    "stormwater tributary area"
  ],
  "weights_loads": [
    "dead load",
    "live load",
    "roof load",
    "floor load",
    "point load",
    "line load",
    "uniform load",
    "wind load",
    "seismic weight",
    "tributary seismic weight",
    "snow load",
    "rain load",
    "equipment weight",
    "panel weight",
    "member weight",
    "shipping weight",
    "lift weight",
    "crane pick weight",
    "ballast weight",
    "mass",
    "density",
    "load per stud",
    "load per anchor",
    "factored load note",
    "unfactored load note"
  ],
  "counts_quantities": [
    "count",
    "quantity",
    "each",
    "number of",
    "fixture count",
    "device count",
    "head count",
    "sprinkler count",
    "outlet count",
    "panel circuit count",
    "sheet count",
    "panel count",
    "module count",
    "pile count",
    "anchor count",
    "weld count",
    "bolt count",
    "stud count",
    "pair count doors",
    "parking stall count",
    "bicycle parking count",
    "linear feet",
    "square feet",
    "cubic yards",
    "man-hours",
    "allowance quantity"
  ],
  "mep_flow_and_performance": [
    "supply airflow CFM",
    "return airflow CFM",
    "exhaust airflow CFM",
    "outdoor air CFM",
    "total airflow CFM",
    "face velocity",
    "duct velocity",
    "static pressure",
    "velocity pressure",
    "design GPM",
    "flow rate",
    "domestic flow rate",
    "drainage fixture units note",
    "water supply fixture units note",
    "pump head",
    "NPSH note",
    "sump discharge GPM",
    "pipe size callout",
    "duct width and height",
    "refrigerant line size",
    "coil entering air temperature",
    "coil leaving air temperature",
    "delta-T",
    "BTU per hour",
    "cooling tons",
    "heating MBH",
    "percent outside air",
    "relative humidity setpoint",
    "dew point note",
    "hydronic design supply temperature",
    "hydronic design return temperature",
    "steam pressure note",
    "condensate GPM",
    "gas pressure note",
    "medical gas pressure note",
    "compressed air pressure note"
  ],
  "electrical_power_and_signal": [
    "voltage",
    "amperage",
    "phase",
    "wattage",
    "volt-amperes",
    "KVA",
    "demand KW",
    "available fault current",
    "interrupting rating",
    "wire size",
    "conductor size",
    "conduit size",
    "conduit fill percent",
    "conductor count",
    "grounding conductor size",
    "neutral conductor count",
    "voltage drop note",
    "short circuit rating note",
    "arc flash label reference",
    "disconnect rating",
    "breaker frame size",
    "trip setting note",
    "motor HP",
    "full load amperes",
    "lighting footcandle target",
    "illuminance lux target",
    "control voltage",
    "DALI group note",
    "dimming percent",
    "photocell setpoint",
    "emergency duration note",
    "battery runtime note",
    "fiber strand count",
    "category cable type callout"
  ],
  "fire_life_outputs": [
    "sprinkler design density",
    "remote area of sprinkler operation",
    "hydraulic demand note",
    "hose stream allowance",
    "sprinkler spacing dimension",
    "deflector obstruction dimension",
    "ceiling height above sprinkler",
    "standpipe residual pressure",
    "fire flow demand",
    "smoke layer design height",
    "door fire rating annotation",
    "wall fire rating annotation",
    "floor ceiling assembly rating",
    "exit access travel distance",
    "common path of egress travel",
    "exit discharge distance",
    "exit width",
    "stair width",
    "occupant load",
    "egress capacity calculation note",
    "smoke compartment area",
    "fire barrier continuity note",
    "draft curtain depth",
    "smoke damper size"
  ],
  "assembly_material_callouts": [
    "concrete compressive strength callout",
    "rebar grade and size",
    "weld symbol reference",
    "bolt grade and diameter",
    "anchor specification callout",
    "mortar type callout",
    "masonry unit strength",
    "steel grade callout",
    "metal deck gauge",
    "glass make-up each ply thickness",
    "insulating glass unit overall thickness",
    "wind load design pressure on cladding",
    "fastener pattern spacing",
    "pre-tension torque note",
    "fire-resistance rated assembly note",
    "UL assembly listing reference",
    "STC assembly rating",
    "IIC rating note",
    "impact protection rating",
    "missile impact zone note",
    "vapor permeance note",
    "perm rating",
    "R-value callout",
    "continuous insulation R-value"
  ],
  "civil_station_geometry": [
    "station along alignment",
    "offset from centerline",
    "PI station",
    "curve radius",
    "tangent length",
    "arc length curve",
    "degree of curve",
    "spiral length",
    "vertical curve K-value",
    "vertical curve length",
    "high point low point station",
    "subgrade elevation",
    "finished grade elevation",
    "sump depth",
    "manhole rim to invert",
    "pipe run length between structures",
    "invert in invert out",
    "pipe cover depth",
    "trench width",
    "swale depth",
    "detention volume",
    "retention volume",
    "erosion control blanket area"
  ],
  "elevator_conveying_outputs": [
    "cab clear width",
    "cab clear depth",
    "cab clear height",
    "door clear width",
    "door clear height",
    "elevator travel",
    "pit depth",
    "overhead clearance",
    "machine room minimum dimensions",
    "rated load pounds",
    "rated load persons",
    "speed FPM",
    "grouping control ID",
    "escalator rise",
    "escalator angle",
    "moving walk length"
  ],
  "schedules_indices": [
    "door schedule",
    "window schedule",
    "finish schedule",
    "hardware schedule",
    "panel schedule",
    "equipment schedule",
    "fixture schedule",
    "load schedule",
    "panel schedule electrical",
    "diffuser schedule",
    "sprinkler schedule",
    "valve schedule",
    "manhole schedule",
    "room finish schedule",
    "room data sheet reference",
    "BAS points list reference",
    "I O schedule reference",
    "drawing index",
    "sheet index",
    "revision index",
    "keynote legend",
    "abbreviation legend",
    "symbol legend",
    "ladder diagram reference",
    "riser diagram reference",
    "one-line reference"
  ],
  "references_datums": [
    "grid dimension",
    "grid intersection",
    "column grid ID",
    "level ID",
    "datum note",
    "benchmark callout",
    "survey reference",
    "property line tie",
    "true north to project north angle",
    "coordinate system note",
    "state plane zone note",
    "control joint location",
    "expansion joint location",
    "construction joint location",
    "pour break",
    "panel joint",
    "module ID",
    "piece mark",
    "shipping mark",
    "erection mark",
    "shop drawing reference",
    "specification section reference",
    "detail reference",
    "sheet reference",
    "RFI reference",
    "submittal reference"
  ],
  "tolerances_quality": [
    "tolerance",
    "flatness tolerance",
    "levelness tolerance",
    "straightness tolerance",
    "plumb tolerance",
    "joint tolerance",
    "gap tolerance",
    "weld tolerance",
    "anchor bolt template tolerance",
    "bolt hole tolerance",
    "precast erection tolerance",
    "concrete strength",
    "slump",
    "air content",
    "cure time",
    "inspection hold point",
    "test pressure",
    "leak test",
    "duct leakage class note",
    "commissioning setpoint",
    "as-built variance",
    "thermal imaging note"
  ],
  "time_sequence": [
    "construction sequence",
    "phasing note",
    "install order",
    "prerequisite work",
    "temporary support note",
    "cure before load",
    "dry-in milestone",
    "substantial completion marker"
  ],
  "graphic_presentation": [
    "enlarged plan",
    "enlarged elevation",
    "isometric",
    "axonometric",
    "perspective",
    "exploded axonometric",
    "diagrammatic flow",
    "schematic riser",
    "schematic one-line",
    "single line diagram",
    "clash snapshot",
    "rendering",
    "photo inset",
    "underlay",
    "halftone ghost",
    "workset tint",
    "color-fill plan",
    "hatch pattern callout",
    "pattern direction note",
    "north arrow",
    "graphic scale",
    "bar scale",
    "matchline",
    "scope box note",
    "view title",
    "sheet border",
    "LOD note"
  ],
  "bim_sheet_metadata": [
    "sheet scale notation",
    "not to scale flag",
    "revision number",
    "issue date",
    "file name reference",
    "model link note",
    "workset responsibility note",
    "survey base point note",
    "project base point note",
    "shared coordinates note"
  ],
  "text_notes_flags": [
    "general note",
    "keynote",
    "leader note",
    "revision cloud",
    "revision triangle",
    "issue tag",
    "warranty note",
    "coordination note",
    "field verify note",
    "not to scale note",
    "typical note",
    "see structural note",
    "see MEP note",
    "by others note",
    "NIC note",
    "TBD note",
    "placeholder note",
    "means and methods note"
  ],
  "safety_logistics": [
    "fall protection zone",
    "guardrail height",
    "toe board height",
    "warning line offset",
    "exclusion zone",
    "laydown area extent",
    "crane swing radius",
    "pick radius",
    "load chart reference",
    "hazard callout",
    "PPE note",
    "hot work boundary",
    "confined space note"
  ],
  "environmental_sustainability": [
    "embodied carbon note",
    "recycled content callout",
    "VOC note",
    "thermal performance value",
    "U-factor callout",
    "SHGC callout",
    "VT callout",
    "air leakage rate assembly",
    "water use intensity note",
    "daylight factor",
    "acoustic STC callout",
    "IEQ note",
    "rainwater harvesting capacity",
    "solar panel area"
  ]
};

export const DIMENSIONAL_OUTPUT_GROUP_LABELS = {
  "linear_dimensions": "Linear & chain dimensions",
  "spot_instrument_dimensions": "Spot elevation, slope & coordinates",
  "offsets_alignments": "Offsets, alignments & clearances",
  "vertical_elevation": "Elevations & vertical geometry",
  "depths_thicknesses": "Thicknesses & build-up depth",
  "sections_cuts": "Sections, clips & extents",
  "angles_slopes": "Angles & slopes",
  "areas_volumes": "Areas & volumes",
  "weights_loads": "Loads & weights",
  "counts_quantities": "Counts & quantities",
  "mep_flow_and_performance": "MEP flow, pressure & capacity",
  "electrical_power_and_signal": "Electrical power & signal",
  "fire_life_outputs": "Fire protection & life safety metrics",
  "assembly_material_callouts": "Assembly, material & rating callouts",
  "civil_station_geometry": "Civil alignment, station & drainage",
  "elevator_conveying_outputs": "Elevator & conveying sizes",
  "schedules_indices": "Schedules, legends & indices",
  "references_datums": "References & datums",
  "tolerances_quality": "Tolerances, tests & QC",
  "time_sequence": "Sequence & phasing",
  "graphic_presentation": "Graphic presentation",
  "bim_sheet_metadata": "BIM & sheet metadata",
  "text_notes_flags": "Notes & revision graphics",
  "safety_logistics": "Safety & logistics",
  "environmental_sustainability": "Sustainability & environmental"
};

export const ALL_REFERENCE_ANNOTATION_KINDS = [
  "3D view reference",
  "abbreviation legend",
  "accessibility legend",
  "accessibility note",
  "accessibility symbol",
  "accessibility symbol tag",
  "accessible entrance symbol",
  "accessible parking symbol",
  "accessible route arrow",
  "accessible stall symbol",
  "acoustic note",
  "air barrier continuity note",
  "airflow diagram reference",
  "alignment station label",
  "anchor tag",
  "area of refuge sign",
  "area tag",
  "as-built markup",
  "assembly mark",
  "assembly section marker",
  "assembly tag",
  "axonometric callout",
  "bar scale",
  "BAS point tag",
  "BAS points list on sheet",
  "basis of design reference",
  "bearing distance callout",
  "benchmark symbol",
  "BIM issue reference",
  "bollard tag",
  "bolt mark",
  "boxed note",
  "break line",
  "building elevation marker",
  "building line label",
  "building section marker",
  "by others flag",
  "by others tag",
  "catch basin tag",
  "ceiling tag",
  "ceiling type legend",
  "circuit ID",
  "clash report reference",
  "clash snapshot reference",
  "clear floor space diagram",
  "clouded area note",
  "code compliance note",
  "code section reference graphic",
  "color-fill legend tie-in",
  "column grid label",
  "commissioning document reference",
  "common path annotation",
  "company logo block",
  "concrete legend",
  "connection mark",
  "connection tag",
  "contour interval legend",
  "contour label",
  "control diagram reference",
  "control point symbol",
  "coordination matrix reference",
  "coordination note leader",
  "crop region",
  "curtain wall elevation marker",
  "curtain wall panel tag",
  "curtain wall unit mark",
  "curve data callout",
  "cut fill limit label",
  "datum head",
  "datum note",
  "delta markup",
  "demolition graphic style",
  "demolition legend",
  "demolition tag",
  "design intent reference",
  "detail boundary",
  "detail callout",
  "detail number",
  "detail reference",
  "detail section marker",
  "detectable warning note",
  "detention basin label",
  "diagram boundary",
  "diagram callout",
  "diffuser schedule on sheet",
  "diffuser tag",
  "diffuser type legend",
  "discipline designation block",
  "door maneuvering clearance diagram",
  "door number",
  "door schedule on sheet",
  "door tag",
  "door type legend",
  "draft curtain tag",
  "drawing index entry",
  "drawing number",
  "duct isometric reference",
  "duct section mark",
  "duct system tag",
  "duct tag",
  "easement graphic",
  "easement label",
  "egress path arrow",
  "electrical circuit tag",
  "electrical device legend",
  "elevation callout",
  "elevation direction arrow",
  "elevation reference bubble",
  "elevation tag",
  "elevator tag",
  "energy note",
  "enlarged plan callout",
  "envelope section marker",
  "equipment connection diagram",
  "equipment schedule on sheet",
  "equipment tag",
  "equipment tag number",
  "erection mark",
  "erosion control note",
  "escalator tag",
  "existing to remain tag",
  "exit sign symbol",
  "exit width annotation graphic",
  "exterior elevation marker",
  "facade elevation marker",
  "fence tag",
  "field verify flag",
  "field verify note",
  "file name reference",
  "finish code mark",
  "finish floor level marker",
  "finish legend",
  "finish schedule on sheet",
  "finish tag",
  "fire alarm device tag",
  "fire barrier tag",
  "fire command center sign",
  "fire damper tag",
  "fire door tag",
  "fire extinguisher location tag",
  "fire lane label",
  "fire protection legend",
  "fire rating note leader",
  "fire rating tag",
  "fire-rated assembly section marker",
  "firestopping note",
  "fixture schedule on sheet",
  "flag note",
  "floor finish legend",
  "floor tag",
  "foundation section marker",
  "foundation tag",
  "furniture tag",
  "general note",
  "grab bar elevation reference",
  "grading legend",
  "grading limit line",
  "graphic scale",
  "grid bubble",
  "grid head",
  "grille tag",
  "halftone region",
  "handrail extension note",
  "hardware schedule on sheet",
  "hatch direction note",
  "hatch pattern legend",
  "hearing loop symbol",
  "hidden line note",
  "hose cabinet tag",
  "hydraulic diagram reference",
  "I O schedule on sheet",
  "inlet tag",
  "installation note",
  "interior elevation callout",
  "interior elevation marker",
  "interior partition section marker",
  "interior perspective reference",
  "invert label",
  "invert level marker",
  "isometric callout",
  "issue cloud",
  "issue date block",
  "issue tag",
  "key plan zone mark",
  "keyed schedule reference",
  "keyed section marker",
  "keynote leader",
  "keynote legend",
  "keynote tag",
  "ladder diagram reference",
  "landscape legend",
  "leader note",
  "level annotation",
  "level head",
  "level symbol",
  "life safety legend",
  "light fixture tag",
  "lighting fixture legend",
  "line style override note",
  "line weight legend",
  "linetype legend",
  "load schedule on sheet",
  "loading zone label",
  "LOD note",
  "manhole schedule on sheet",
  "manhole tag",
  "masonry legend",
  "matchline",
  "material callout leader",
  "material legend",
  "material tag",
  "means and methods note",
  "mechanical equipment legend",
  "mechanical equipment tag",
  "MEP section marker",
  "millwork elevation marker",
  "model link note",
  "module ID",
  "motor tag",
  "Navisworks viewpoint reference",
  "new work graphic style",
  "new work tag",
  "NIC flag",
  "NIC tag",
  "north arrow",
  "not to scale flag",
  "occupancy tag",
  "occupant load placard",
  "one-line reference bubble",
  "OPR reference",
  "panel designation",
  "panel mark",
  "panel schedule on sheet",
  "panel schedule tie-in",
  "panel tag",
  "panel type legend",
  "parking stall stripe",
  "parking stall tag",
  "partial section marker",
  "pattern scale note",
  "pavement marking legend",
  "paving legend",
  "penetration note",
  "perspective callout",
  "phantom line note",
  "phase graphic override",
  "phase tag",
  "phasing legend",
  "phasing note",
  "photo reference inset",
  "PI station label",
  "piece mark",
  "pile tag",
  "pipe size label on plan",
  "pipe spool mark",
  "pipe tag",
  "piping system tag",
  "placeholder flag",
  "placeholder tag",
  "plan callout",
  "plant tag",
  "plumbing fixture legend",
  "plumbing fixture tag",
  "plumbing isometric reference",
  "precast panel mark",
  "prefab module mark",
  "profession seal",
  "project base point note",
  "property corner label",
  "property corner monument",
  "property line label",
  "railing tag",
  "ramp slope diagram",
  "rated floor ceiling tag",
  "rated wall tag",
  "rebar tag",
  "receptacle tag",
  "record drawing markup",
  "redline markup",
  "reference bubble",
  "reference note",
  "reference plane tag",
  "reflected ceiling plan callout",
  "rendering reference",
  "retaining wall elevation marker",
  "revision block",
  "revision cloud",
  "revision delta",
  "revision tag",
  "revision triangle",
  "RFI reference",
  "right-of-way label",
  "rim label",
  "rim level marker",
  "riser diagram callout",
  "roof plan callout",
  "roof plan elevation indicator",
  "roof section marker",
  "roof tag",
  "roof type legend",
  "room data sheet on sheet",
  "room finish schedule on sheet",
  "room number",
  "room tag",
  "safety note",
  "scale notation",
  "schematic callout",
  "schematic flow arrow",
  "scope box",
  "scope box label",
  "section arrow head",
  "section box graphic",
  "section callout",
  "section cut line",
  "section reference number",
  "section tail",
  "see detail",
  "see diagram",
  "see elevation",
  "see enlarged plan",
  "see floor plan",
  "see MEP note",
  "see one-line diagram",
  "see reflected ceiling plan",
  "see riser diagram",
  "see roof plan",
  "see schedule",
  "see section",
  "see site plan",
  "see specification section",
  "see structural note",
  "sequence note",
  "sequence of operation reference",
  "setback line label",
  "shared coordinates note",
  "sheet border",
  "sheet index entry",
  "sheet number",
  "sheet reference bubble",
  "sheet title",
  "shipping mark",
  "shop drawing mark",
  "shop drawing reference",
  "signage elevation marker",
  "signage schedule on sheet",
  "signage tag",
  "signage type legend",
  "silt fence line",
  "single line diagram reference",
  "site elevation marker",
  "site furnishing tag",
  "site legend",
  "site section marker",
  "sketch markup",
  "smoke barrier tag",
  "smoke compartment tag",
  "smoke damper tag",
  "smoke detector tag",
  "space tag",
  "specification note leader",
  "specification section reference graphic",
  "spot grade callout graphic",
  "sprinkler head tag",
  "sprinkler schedule on sheet",
  "sprinkler type legend",
  "stair elevation marker",
  "stair identification sign",
  "stair section callout",
  "stair section marker",
  "stair tag",
  "standpipe connection tag",
  "standpipe tag",
  "station equation",
  "striping legend",
  "structural beam tag",
  "structural brace tag",
  "structural column tag",
  "structural grid label",
  "structural section marker",
  "structural steel legend",
  "submittal reference",
  "survey base point note",
  "survey benchmark callout",
  "survey legend",
  "switch tag",
  "SWPPP reference",
  "symbol legend",
  "system abbreviation tag",
  "TBD flag",
  "TBD tag",
  "TDD symbol",
  "test report reference",
  "tilt-up panel mark",
  "title block",
  "toilet clearance diagram",
  "top of concrete marker",
  "top of deck marker",
  "top of steel marker",
  "traffic sign legend",
  "transformer tag",
  "travel distance annotation",
  "tree protection zone",
  "tree tag",
  "true north to project north note",
  "turning radius diagram",
  "typical note",
  "UL assembly listing reference graphic",
  "underlay ghost graphic",
  "underside of deck marker",
  "utility elevation marker",
  "utility legend",
  "utility line label",
  "utility pole tag",
  "valve schedule on sheet",
  "valve tag",
  "valve tag number",
  "valve type legend",
  "view range graphic",
  "view reference bubble",
  "view title",
  "visual alarm symbol",
  "wall section callout",
  "wall section marker",
  "wall tag",
  "wall type legend",
  "wall type section marker",
  "wall type tag",
  "warranty note",
  "waterproofing note",
  "weld mark",
  "wetland boundary label",
  "window schedule on sheet",
  "window tag",
  "window type legend",
  "window type mark",
  "work plane graphic",
  "work plane tag",
  "workset responsibility note",
  "workset tint legend"
];

export const ALL_DIMENSIONAL_OUTPUT_KINDS = [
  "abbreviation legend",
  "acoustic STC callout",
  "air cavity depth",
  "air content",
  "air leakage rate assembly",
  "aligned dimension",
  "allowance quantity",
  "amperage",
  "anchor bolt template tolerance",
  "anchor count",
  "anchor embedment",
  "anchor specification callout",
  "angle",
  "arc flash label reference",
  "arc length",
  "arc length curve",
  "area gross",
  "area net",
  "as-built variance",
  "available fault current",
  "axonometric",
  "azimuth",
  "ballast weight",
  "bar scale",
  "bar spacing dimension",
  "BAS points list reference",
  "baseline dimension",
  "battery runtime note",
  "bay spacing",
  "bearing angle",
  "bearing offset",
  "benchmark callout",
  "benchmark elevation",
  "bevel angle",
  "bicycle parking count",
  "bolt count",
  "bolt grade and diameter",
  "bolt hole tolerance",
  "bottom of footing",
  "bottom of wall",
  "break line offset",
  "breaker frame size",
  "BTU per hour",
  "building section cut line",
  "by others note",
  "cab clear depth",
  "cab clear height",
  "cab clear width",
  "callout extent",
  "camber",
  "catchment area",
  "category cable type callout",
  "ceiling elevation",
  "ceiling height above sprinkler",
  "chain dimension",
  "chord length",
  "cladding thickness",
  "clash snapshot",
  "clear height",
  "clear opening height",
  "clear opening width",
  "coating thickness",
  "coil entering air temperature",
  "coil leaving air temperature",
  "color-fill plan",
  "column grid ID",
  "commissioning setpoint",
  "common path of egress travel",
  "compressed air pressure note",
  "concrete compressive strength callout",
  "concrete strength",
  "concrete volume",
  "concrete yardage",
  "condensate GPM",
  "conductor count",
  "conductor size",
  "conduit fill percent",
  "conduit size",
  "confined space note",
  "construction joint location",
  "construction sequence",
  "continuous dimension",
  "continuous insulation R-value",
  "control joint location",
  "control voltage",
  "cooling tons",
  "coordinate system note",
  "coordination note",
  "count",
  "counterbore depth",
  "countersink depth",
  "cover concrete",
  "cover depth below grade",
  "cover to reinforcement",
  "crane pick weight",
  "crane swing radius",
  "crop region",
  "cross slope",
  "cubic yards",
  "cure before load",
  "cure time",
  "curve radius",
  "cut length",
  "DALI group note",
  "datum elevation",
  "datum note",
  "daylight factor",
  "dead load",
  "deflection angle",
  "deflector obstruction dimension",
  "degree of curve",
  "delta-T",
  "demand KW",
  "density",
  "design GPM",
  "detail boundary extent",
  "detail cut scope",
  "detail reference",
  "detention volume",
  "development length",
  "development length rebar",
  "device count",
  "dew point note",
  "diagrammatic flow",
  "diameter",
  "diffuser schedule",
  "dimming percent",
  "disconnect rating",
  "domestic flow rate",
  "door clear height",
  "door clear width",
  "door fire rating annotation",
  "door schedule",
  "door swing clearance",
  "draft curtain depth",
  "drainage fixture units note",
  "drainage mat thickness",
  "drawing index",
  "drop",
  "dry-in milestone",
  "duct leakage class note",
  "duct slope percent",
  "duct velocity",
  "duct width and height",
  "each",
  "eccentricity",
  "edge distance",
  "egress capacity calculation note",
  "elevation",
  "elevator travel",
  "embed depth",
  "embodied carbon note",
  "emergency duration note",
  "end distance",
  "enlarged elevation",
  "enlarged plan",
  "equipment schedule",
  "equipment weight",
  "erection mark",
  "erosion control blanket area",
  "escalator angle",
  "escalator rise",
  "excavation volume",
  "exclusion zone",
  "exhaust airflow CFM",
  "exit access travel distance",
  "exit discharge distance",
  "exit width",
  "expansion joint location",
  "exploded axonometric",
  "face velocity",
  "factored load note",
  "fall protection zone",
  "far clip offset",
  "fastener pattern spacing",
  "fiber strand count",
  "field verify note",
  "file name reference",
  "fill volume",
  "finish schedule",
  "finished floor elevation",
  "finished grade elevation",
  "fire barrier continuity note",
  "fire flow demand",
  "fire-resistance rated assembly note",
  "fixture count",
  "fixture schedule",
  "flange thickness",
  "flatness tolerance",
  "floor area",
  "floor ceiling assembly rating",
  "floor load",
  "floor-to-floor height",
  "flow rate",
  "formwork area",
  "full load amperes",
  "gap tolerance",
  "gas pressure note",
  "gauge",
  "general note",
  "glass make-up each ply thickness",
  "glazing area",
  "glazing ratio",
  "going dimension",
  "grade elevation",
  "graphic scale",
  "grid dimension",
  "grid intersection",
  "groove depth",
  "grounding conductor size",
  "grouping control ID",
  "guardrail height",
  "gypsum layer thickness",
  "halftone ghost",
  "hardware schedule",
  "hatch pattern callout",
  "hazard callout",
  "head count",
  "head elevation",
  "headroom",
  "heating MBH",
  "high point low point station",
  "hose stream allowance",
  "hot work boundary",
  "hydraulic demand note",
  "hydronic design return temperature",
  "hydronic design supply temperature",
  "I O schedule reference",
  "IEQ note",
  "IIC rating note",
  "illuminance lux target",
  "impact protection rating",
  "in-plane offset",
  "included angle",
  "inset",
  "inspection hold point",
  "install order",
  "insulating glass unit overall thickness",
  "insulation board feet",
  "insulation thickness",
  "interrupting rating",
  "invert elevation",
  "invert in invert out",
  "invert spot",
  "isometric",
  "issue date",
  "issue tag",
  "joint spacing",
  "joint tolerance",
  "kerf depth",
  "keynote",
  "keynote legend",
  "KVA",
  "ladder diagram reference",
  "laminated build-up thickness",
  "lap length",
  "laydown area extent",
  "leader note",
  "leak test",
  "level ID",
  "level relative to datum",
  "level tolerance",
  "levelness tolerance",
  "lift weight",
  "lighting footcandle target",
  "line load",
  "linear dimension",
  "linear feet",
  "live load",
  "load chart reference",
  "load per anchor",
  "load per stud",
  "load schedule",
  "LOD note",
  "longitudinal slope",
  "machine room minimum dimensions",
  "man-hours",
  "maneuvering clearance",
  "manhole rim to invert",
  "manhole schedule",
  "masonry unit strength",
  "mass",
  "matchline",
  "matchline offset",
  "maximum dimension string",
  "maximum span",
  "means and methods note",
  "medical gas pressure note",
  "member weight",
  "membrane thickness",
  "mesh spacing dimension",
  "metal deck gauge",
  "minimum clearance",
  "minimum dimension string",
  "missile impact zone note",
  "miter angle",
  "model link note",
  "module count",
  "module ID",
  "module spacing",
  "mortar type callout",
  "motor HP",
  "moving walk length",
  "near clip offset",
  "neutral conductor count",
  "NIC note",
  "normal distance",
  "north arrow",
  "nosing projection",
  "not to scale flag",
  "not to scale note",
  "NPSH note",
  "number of",
  "occupant load",
  "occupant load area basis",
  "offset from baseline",
  "offset from building line",
  "offset from centerline",
  "offset from column centerline",
  "offset from core",
  "offset from easement",
  "offset from finish face",
  "offset from grid",
  "offset from grid line",
  "offset from property line",
  "offset from right-of-way",
  "offset from structure face",
  "offset from wall centerline",
  "on-center spacing",
  "one-line reference",
  "opening area",
  "opening height",
  "opening width",
  "ordinate dimension",
  "out-of-plane offset",
  "outdoor air CFM",
  "outlet count",
  "overall length",
  "overall width",
  "overhead clearance",
  "paint area",
  "pair count doors",
  "panel circuit count",
  "panel count",
  "panel joint",
  "panel schedule",
  "panel schedule electrical",
  "panel weight",
  "parallel offset",
  "parapet elevation",
  "parking stall count",
  "partial section",
  "pattern direction note",
  "pavement structure layer thickness",
  "penetration depth",
  "percent outside air",
  "percent slope",
  "perimeter linear",
  "perm rating",
  "perspective",
  "phase",
  "phasing note",
  "photo inset",
  "photocell setpoint",
  "PI station",
  "pick radius",
  "piece mark",
  "pile count",
  "pipe cover depth",
  "pipe run length between structures",
  "pipe size callout",
  "pipe slope percent",
  "pit depth",
  "pitch",
  "placeholder note",
  "plate thickness",
  "platform elevation",
  "plumb tolerance",
  "pocket door pocket depth",
  "point load",
  "pour break",
  "PPE note",
  "pre-tension torque note",
  "precast erection tolerance",
  "prerequisite work",
  "project base point note",
  "property line tie",
  "pump head",
  "quantity",
  "R-value callout",
  "rabbet depth",
  "radius",
  "rain load",
  "rainwater harvesting capacity",
  "rake angle",
  "rated load persons",
  "rated load pounds",
  "rebar grade and size",
  "recycled content callout",
  "reflected ceiling plane elevation",
  "refrigerant line size",
  "relative elevation",
  "relative humidity setpoint",
  "remote area of sprinkler operation",
  "rendering",
  "rentable area",
  "repetitive spacing",
  "retention volume",
  "return airflow CFM",
  "reveal depth",
  "reveal width",
  "revision cloud",
  "revision index",
  "revision number",
  "revision triangle",
  "RFI reference",
  "rim elevation",
  "rim spot",
  "riser diagram reference",
  "riser height",
  "roof area",
  "roof elevation",
  "roof load",
  "room data sheet reference",
  "room finish schedule",
  "rotation",
  "rough opening height",
  "rough opening width",
  "running dimension",
  "schematic one-line",
  "schematic riser",
  "scope box note",
  "scope of demolition",
  "scope of new work",
  "seam length",
  "section cut depth",
  "section reference",
  "see MEP note",
  "see structural note",
  "seismic weight",
  "setback",
  "setback from ROW",
  "shared coordinates note",
  "sheathing thickness",
  "sheet border",
  "sheet count",
  "sheet index",
  "sheet reference",
  "sheet scale notation",
  "SHGC callout",
  "shipping mark",
  "shipping weight",
  "shop drawing reference",
  "short circuit rating note",
  "sill elevation",
  "single line diagram",
  "skew",
  "slab thickness",
  "sleeve length through wall",
  "slope arrow",
  "slope ratio",
  "slump",
  "smoke compartment area",
  "smoke damper size",
  "smoke layer design height",
  "snow load",
  "soffit elevation",
  "solar panel area",
  "span",
  "specification section reference",
  "speed FPM",
  "spiral length",
  "splice length",
  "split line offset",
  "spot coordinate",
  "spot easting northing",
  "spot elevation",
  "spot grade",
  "spot slope",
  "sprinkler count",
  "sprinkler design density",
  "sprinkler schedule",
  "sprinkler spacing dimension",
  "square feet",
  "stair width",
  "standpipe residual pressure",
  "state plane zone note",
  "static pressure",
  "station along alignment",
  "STC assembly rating",
  "steam pressure note",
  "steel grade callout",
  "step height",
  "stock length",
  "stormwater tributary area",
  "story height",
  "straightness tolerance",
  "structural top of steel",
  "stud count",
  "stud leg length",
  "subbase thickness",
  "subgrade elevation",
  "submittal reference",
  "substantial completion marker",
  "sump depth",
  "sump discharge GPM",
  "supply airflow CFM",
  "surface area",
  "survey base point note",
  "survey elevation",
  "survey reference",
  "swale depth",
  "sweep angle",
  "symbol legend",
  "tangent length",
  "TBD note",
  "temporary support note",
  "test pressure",
  "thermal imaging note",
  "thermal performance value",
  "throat dimension",
  "toe board height",
  "tolerance",
  "tonnage steel",
  "top of blocking",
  "top of concrete",
  "top of deck",
  "top of footing",
  "top of wall",
  "top of wall framing",
  "topping thickness",
  "total airflow CFM",
  "total rise",
  "total wall assembly thickness",
  "tread depth",
  "trench depth",
  "trench width",
  "tributary seismic weight",
  "trip setting note",
  "true length vs projected length",
  "true north to project north angle",
  "typical note",
  "U-factor callout",
  "UL assembly listing reference",
  "underlay",
  "underside of deck",
  "unfactored load note",
  "uniform load",
  "usable area",
  "valve schedule",
  "vapor permeance note",
  "velocity pressure",
  "veneer thickness",
  "vertical curve K-value",
  "vertical curve length",
  "vertical rise",
  "view depth",
  "view title",
  "VOC note",
  "volt-amperes",
  "voltage",
  "voltage drop note",
  "volume",
  "VT callout",
  "wall area",
  "wall fire rating annotation",
  "warning line offset",
  "warranty note",
  "water supply fixture units note",
  "water use intensity note",
  "waterproofing area",
  "waterproofing build-up thickness",
  "wattage",
  "web thickness",
  "weld count",
  "weld length",
  "weld symbol reference",
  "weld tolerance",
  "wind load",
  "wind load design pressure on cladding",
  "window schedule",
  "wire size",
  "work plane offset",
  "work point offset",
  "workset responsibility note",
  "workset tint"
];

export const ALL_MAPPING_KINDS = [
  "3D view reference",
  "abbreviation legend",
  "accessibility legend",
  "accessibility note",
  "accessibility symbol",
  "accessibility symbol tag",
  "accessible entrance symbol",
  "accessible parking symbol",
  "accessible route arrow",
  "accessible stall symbol",
  "acoustic note",
  "acoustic STC callout",
  "air barrier continuity note",
  "air cavity depth",
  "air content",
  "air leakage rate assembly",
  "airflow diagram reference",
  "aligned dimension",
  "alignment station label",
  "allowance quantity",
  "amperage",
  "anchor bolt template tolerance",
  "anchor count",
  "anchor embedment",
  "anchor specification callout",
  "anchor tag",
  "angle",
  "arc flash label reference",
  "arc length",
  "arc length curve",
  "area gross",
  "area net",
  "area of refuge sign",
  "area tag",
  "as-built markup",
  "as-built variance",
  "assembly mark",
  "assembly section marker",
  "assembly tag",
  "available fault current",
  "axonometric",
  "axonometric callout",
  "azimuth",
  "ballast weight",
  "bar scale",
  "bar spacing dimension",
  "BAS point tag",
  "BAS points list on sheet",
  "BAS points list reference",
  "baseline dimension",
  "basis of design reference",
  "battery runtime note",
  "bay spacing",
  "bearing angle",
  "bearing distance callout",
  "bearing offset",
  "benchmark callout",
  "benchmark elevation",
  "benchmark symbol",
  "bevel angle",
  "bicycle parking count",
  "BIM issue reference",
  "bollard tag",
  "bolt count",
  "bolt grade and diameter",
  "bolt hole tolerance",
  "bolt mark",
  "bottom of footing",
  "bottom of wall",
  "boxed note",
  "break line",
  "break line offset",
  "breaker frame size",
  "BTU per hour",
  "building elevation marker",
  "building line label",
  "building section cut line",
  "building section marker",
  "by others flag",
  "by others note",
  "by others tag",
  "cab clear depth",
  "cab clear height",
  "cab clear width",
  "callout extent",
  "camber",
  "catch basin tag",
  "catchment area",
  "category cable type callout",
  "ceiling elevation",
  "ceiling height above sprinkler",
  "ceiling tag",
  "ceiling type legend",
  "chain dimension",
  "chord length",
  "circuit ID",
  "cladding thickness",
  "clash report reference",
  "clash snapshot",
  "clash snapshot reference",
  "clear floor space diagram",
  "clear height",
  "clear opening height",
  "clear opening width",
  "clouded area note",
  "coating thickness",
  "code compliance note",
  "code section reference graphic",
  "coil entering air temperature",
  "coil leaving air temperature",
  "color-fill legend tie-in",
  "color-fill plan",
  "column grid ID",
  "column grid label",
  "commissioning document reference",
  "commissioning setpoint",
  "common path annotation",
  "common path of egress travel",
  "company logo block",
  "compressed air pressure note",
  "concrete compressive strength callout",
  "concrete legend",
  "concrete strength",
  "concrete volume",
  "concrete yardage",
  "condensate GPM",
  "conductor count",
  "conductor size",
  "conduit fill percent",
  "conduit size",
  "confined space note",
  "connection mark",
  "connection tag",
  "construction joint location",
  "construction sequence",
  "continuous dimension",
  "continuous insulation R-value",
  "contour interval legend",
  "contour label",
  "control diagram reference",
  "control joint location",
  "control point symbol",
  "control voltage",
  "cooling tons",
  "coordinate system note",
  "coordination matrix reference",
  "coordination note",
  "coordination note leader",
  "count",
  "counterbore depth",
  "countersink depth",
  "cover concrete",
  "cover depth below grade",
  "cover to reinforcement",
  "crane pick weight",
  "crane swing radius",
  "crop region",
  "cross slope",
  "cubic yards",
  "cure before load",
  "cure time",
  "curtain wall elevation marker",
  "curtain wall panel tag",
  "curtain wall unit mark",
  "curve data callout",
  "curve radius",
  "cut fill limit label",
  "cut length",
  "DALI group note",
  "datum elevation",
  "datum head",
  "datum note",
  "daylight factor",
  "dead load",
  "deflection angle",
  "deflector obstruction dimension",
  "degree of curve",
  "delta markup",
  "delta-T",
  "demand KW",
  "demolition graphic style",
  "demolition legend",
  "demolition tag",
  "density",
  "design GPM",
  "design intent reference",
  "detail boundary",
  "detail boundary extent",
  "detail callout",
  "detail cut scope",
  "detail number",
  "detail reference",
  "detail section marker",
  "detectable warning note",
  "detention basin label",
  "detention volume",
  "development length",
  "development length rebar",
  "device count",
  "dew point note",
  "diagram boundary",
  "diagram callout",
  "diagrammatic flow",
  "diameter",
  "diffuser schedule",
  "diffuser schedule on sheet",
  "diffuser tag",
  "diffuser type legend",
  "dimming percent",
  "discipline designation block",
  "disconnect rating",
  "domestic flow rate",
  "door clear height",
  "door clear width",
  "door fire rating annotation",
  "door maneuvering clearance diagram",
  "door number",
  "door schedule",
  "door schedule on sheet",
  "door swing clearance",
  "door tag",
  "door type legend",
  "draft curtain depth",
  "draft curtain tag",
  "drainage fixture units note",
  "drainage mat thickness",
  "drawing index",
  "drawing index entry",
  "drawing number",
  "drop",
  "dry-in milestone",
  "duct isometric reference",
  "duct leakage class note",
  "duct section mark",
  "duct slope percent",
  "duct system tag",
  "duct tag",
  "duct velocity",
  "duct width and height",
  "each",
  "easement graphic",
  "easement label",
  "eccentricity",
  "edge distance",
  "egress capacity calculation note",
  "egress path arrow",
  "electrical circuit tag",
  "electrical device legend",
  "elevation",
  "elevation callout",
  "elevation direction arrow",
  "elevation reference bubble",
  "elevation tag",
  "elevator tag",
  "elevator travel",
  "embed depth",
  "embodied carbon note",
  "emergency duration note",
  "end distance",
  "energy note",
  "enlarged elevation",
  "enlarged plan",
  "enlarged plan callout",
  "envelope section marker",
  "equipment connection diagram",
  "equipment schedule",
  "equipment schedule on sheet",
  "equipment tag",
  "equipment tag number",
  "equipment weight",
  "erection mark",
  "erosion control blanket area",
  "erosion control note",
  "escalator angle",
  "escalator rise",
  "escalator tag",
  "excavation volume",
  "exclusion zone",
  "exhaust airflow CFM",
  "existing to remain tag",
  "exit access travel distance",
  "exit discharge distance",
  "exit sign symbol",
  "exit width",
  "exit width annotation graphic",
  "expansion joint location",
  "exploded axonometric",
  "exterior elevation marker",
  "facade elevation marker",
  "face velocity",
  "factored load note",
  "fall protection zone",
  "far clip offset",
  "fastener pattern spacing",
  "fence tag",
  "fiber strand count",
  "field verify flag",
  "field verify note",
  "file name reference",
  "fill volume",
  "finish code mark",
  "finish floor level marker",
  "finish legend",
  "finish schedule",
  "finish schedule on sheet",
  "finish tag",
  "finished floor elevation",
  "finished grade elevation",
  "fire alarm device tag",
  "fire barrier continuity note",
  "fire barrier tag",
  "fire command center sign",
  "fire damper tag",
  "fire door tag",
  "fire extinguisher location tag",
  "fire flow demand",
  "fire lane label",
  "fire protection legend",
  "fire rating note leader",
  "fire rating tag",
  "fire-rated assembly section marker",
  "fire-resistance rated assembly note",
  "firestopping note",
  "fixture count",
  "fixture schedule",
  "fixture schedule on sheet",
  "flag note",
  "flange thickness",
  "flatness tolerance",
  "floor area",
  "floor ceiling assembly rating",
  "floor finish legend",
  "floor load",
  "floor tag",
  "floor-to-floor height",
  "flow rate",
  "formwork area",
  "foundation section marker",
  "foundation tag",
  "full load amperes",
  "furniture tag",
  "gap tolerance",
  "gas pressure note",
  "gauge",
  "general note",
  "glass make-up each ply thickness",
  "glazing area",
  "glazing ratio",
  "going dimension",
  "grab bar elevation reference",
  "grade elevation",
  "grading legend",
  "grading limit line",
  "graphic scale",
  "grid bubble",
  "grid dimension",
  "grid head",
  "grid intersection",
  "grille tag",
  "groove depth",
  "grounding conductor size",
  "grouping control ID",
  "guardrail height",
  "gypsum layer thickness",
  "halftone ghost",
  "halftone region",
  "handrail extension note",
  "hardware schedule",
  "hardware schedule on sheet",
  "hatch direction note",
  "hatch pattern callout",
  "hatch pattern legend",
  "hazard callout",
  "head count",
  "head elevation",
  "headroom",
  "hearing loop symbol",
  "heating MBH",
  "hidden line note",
  "high point low point station",
  "hose cabinet tag",
  "hose stream allowance",
  "hot work boundary",
  "hydraulic demand note",
  "hydraulic diagram reference",
  "hydronic design return temperature",
  "hydronic design supply temperature",
  "I O schedule on sheet",
  "I O schedule reference",
  "IEQ note",
  "IIC rating note",
  "illuminance lux target",
  "impact protection rating",
  "in-plane offset",
  "included angle",
  "inlet tag",
  "inset",
  "inspection hold point",
  "install order",
  "installation note",
  "insulating glass unit overall thickness",
  "insulation board feet",
  "insulation thickness",
  "interior elevation callout",
  "interior elevation marker",
  "interior partition section marker",
  "interior perspective reference",
  "interrupting rating",
  "invert elevation",
  "invert in invert out",
  "invert label",
  "invert level marker",
  "invert spot",
  "isometric",
  "isometric callout",
  "issue cloud",
  "issue date",
  "issue date block",
  "issue tag",
  "joint spacing",
  "joint tolerance",
  "kerf depth",
  "key plan zone mark",
  "keyed schedule reference",
  "keyed section marker",
  "keynote",
  "keynote leader",
  "keynote legend",
  "keynote tag",
  "KVA",
  "ladder diagram reference",
  "laminated build-up thickness",
  "landscape legend",
  "lap length",
  "laydown area extent",
  "leader note",
  "leak test",
  "level annotation",
  "level head",
  "level ID",
  "level relative to datum",
  "level symbol",
  "level tolerance",
  "levelness tolerance",
  "life safety legend",
  "lift weight",
  "light fixture tag",
  "lighting fixture legend",
  "lighting footcandle target",
  "line load",
  "line style override note",
  "line weight legend",
  "linear dimension",
  "linear feet",
  "linetype legend",
  "live load",
  "load chart reference",
  "load per anchor",
  "load per stud",
  "load schedule",
  "load schedule on sheet",
  "loading zone label",
  "LOD note",
  "longitudinal slope",
  "machine room minimum dimensions",
  "man-hours",
  "maneuvering clearance",
  "manhole rim to invert",
  "manhole schedule",
  "manhole schedule on sheet",
  "manhole tag",
  "masonry legend",
  "masonry unit strength",
  "mass",
  "matchline",
  "matchline offset",
  "material callout leader",
  "material legend",
  "material tag",
  "maximum dimension string",
  "maximum span",
  "means and methods note",
  "mechanical equipment legend",
  "mechanical equipment tag",
  "medical gas pressure note",
  "member weight",
  "membrane thickness",
  "MEP section marker",
  "mesh spacing dimension",
  "metal deck gauge",
  "millwork elevation marker",
  "minimum clearance",
  "minimum dimension string",
  "missile impact zone note",
  "miter angle",
  "model link note",
  "module count",
  "module ID",
  "module spacing",
  "mortar type callout",
  "motor HP",
  "motor tag",
  "moving walk length",
  "Navisworks viewpoint reference",
  "near clip offset",
  "neutral conductor count",
  "new work graphic style",
  "new work tag",
  "NIC flag",
  "NIC note",
  "NIC tag",
  "normal distance",
  "north arrow",
  "nosing projection",
  "not to scale flag",
  "not to scale note",
  "NPSH note",
  "number of",
  "occupancy tag",
  "occupant load",
  "occupant load area basis",
  "occupant load placard",
  "offset from baseline",
  "offset from building line",
  "offset from centerline",
  "offset from column centerline",
  "offset from core",
  "offset from easement",
  "offset from finish face",
  "offset from grid",
  "offset from grid line",
  "offset from property line",
  "offset from right-of-way",
  "offset from structure face",
  "offset from wall centerline",
  "on-center spacing",
  "one-line reference",
  "one-line reference bubble",
  "opening area",
  "opening height",
  "opening width",
  "OPR reference",
  "ordinate dimension",
  "out-of-plane offset",
  "outdoor air CFM",
  "outlet count",
  "overall length",
  "overall width",
  "overhead clearance",
  "paint area",
  "pair count doors",
  "panel circuit count",
  "panel count",
  "panel designation",
  "panel joint",
  "panel mark",
  "panel schedule",
  "panel schedule electrical",
  "panel schedule on sheet",
  "panel schedule tie-in",
  "panel tag",
  "panel type legend",
  "panel weight",
  "parallel offset",
  "parapet elevation",
  "parking stall count",
  "parking stall stripe",
  "parking stall tag",
  "partial section",
  "partial section marker",
  "pattern direction note",
  "pattern scale note",
  "pavement marking legend",
  "pavement structure layer thickness",
  "paving legend",
  "penetration depth",
  "penetration note",
  "percent outside air",
  "percent slope",
  "perimeter linear",
  "perm rating",
  "perspective",
  "perspective callout",
  "phantom line note",
  "phase",
  "phase graphic override",
  "phase tag",
  "phasing legend",
  "phasing note",
  "photo inset",
  "photo reference inset",
  "photocell setpoint",
  "PI station",
  "PI station label",
  "pick radius",
  "piece mark",
  "pile count",
  "pile tag",
  "pipe cover depth",
  "pipe run length between structures",
  "pipe size callout",
  "pipe size label on plan",
  "pipe slope percent",
  "pipe spool mark",
  "pipe tag",
  "piping system tag",
  "pit depth",
  "pitch",
  "placeholder flag",
  "placeholder note",
  "placeholder tag",
  "plan callout",
  "plant tag",
  "plate thickness",
  "platform elevation",
  "plumb tolerance",
  "plumbing fixture legend",
  "plumbing fixture tag",
  "plumbing isometric reference",
  "pocket door pocket depth",
  "point load",
  "pour break",
  "PPE note",
  "pre-tension torque note",
  "precast erection tolerance",
  "precast panel mark",
  "prefab module mark",
  "prerequisite work",
  "profession seal",
  "project base point note",
  "property corner label",
  "property corner monument",
  "property line label",
  "property line tie",
  "pump head",
  "quantity",
  "R-value callout",
  "rabbet depth",
  "radius",
  "railing tag",
  "rain load",
  "rainwater harvesting capacity",
  "rake angle",
  "ramp slope diagram",
  "rated floor ceiling tag",
  "rated load persons",
  "rated load pounds",
  "rated wall tag",
  "rebar grade and size",
  "rebar tag",
  "receptacle tag",
  "record drawing markup",
  "recycled content callout",
  "redline markup",
  "reference bubble",
  "reference note",
  "reference plane tag",
  "reflected ceiling plan callout",
  "reflected ceiling plane elevation",
  "refrigerant line size",
  "relative elevation",
  "relative humidity setpoint",
  "remote area of sprinkler operation",
  "rendering",
  "rendering reference",
  "rentable area",
  "repetitive spacing",
  "retaining wall elevation marker",
  "retention volume",
  "return airflow CFM",
  "reveal depth",
  "reveal width",
  "revision block",
  "revision cloud",
  "revision delta",
  "revision index",
  "revision number",
  "revision tag",
  "revision triangle",
  "RFI reference",
  "right-of-way label",
  "rim elevation",
  "rim label",
  "rim level marker",
  "rim spot",
  "riser diagram callout",
  "riser diagram reference",
  "riser height",
  "roof area",
  "roof elevation",
  "roof load",
  "roof plan callout",
  "roof plan elevation indicator",
  "roof section marker",
  "roof tag",
  "roof type legend",
  "room data sheet on sheet",
  "room data sheet reference",
  "room finish schedule",
  "room finish schedule on sheet",
  "room number",
  "room tag",
  "rotation",
  "rough opening height",
  "rough opening width",
  "running dimension",
  "safety note",
  "scale notation",
  "schematic callout",
  "schematic flow arrow",
  "schematic one-line",
  "schematic riser",
  "scope box",
  "scope box label",
  "scope box note",
  "scope of demolition",
  "scope of new work",
  "seam length",
  "section arrow head",
  "section box graphic",
  "section callout",
  "section cut depth",
  "section cut line",
  "section reference",
  "section reference number",
  "section tail",
  "see detail",
  "see diagram",
  "see elevation",
  "see enlarged plan",
  "see floor plan",
  "see MEP note",
  "see one-line diagram",
  "see reflected ceiling plan",
  "see riser diagram",
  "see roof plan",
  "see schedule",
  "see section",
  "see site plan",
  "see specification section",
  "see structural note",
  "seismic weight",
  "sequence note",
  "sequence of operation reference",
  "setback",
  "setback from ROW",
  "setback line label",
  "shared coordinates note",
  "sheathing thickness",
  "sheet border",
  "sheet count",
  "sheet index",
  "sheet index entry",
  "sheet number",
  "sheet reference",
  "sheet reference bubble",
  "sheet scale notation",
  "sheet title",
  "SHGC callout",
  "shipping mark",
  "shipping weight",
  "shop drawing mark",
  "shop drawing reference",
  "short circuit rating note",
  "signage elevation marker",
  "signage schedule on sheet",
  "signage tag",
  "signage type legend",
  "sill elevation",
  "silt fence line",
  "single line diagram",
  "single line diagram reference",
  "site elevation marker",
  "site furnishing tag",
  "site legend",
  "site section marker",
  "sketch markup",
  "skew",
  "slab thickness",
  "sleeve length through wall",
  "slope arrow",
  "slope ratio",
  "slump",
  "smoke barrier tag",
  "smoke compartment area",
  "smoke compartment tag",
  "smoke damper size",
  "smoke damper tag",
  "smoke detector tag",
  "smoke layer design height",
  "snow load",
  "soffit elevation",
  "solar panel area",
  "space tag",
  "span",
  "specification note leader",
  "specification section reference",
  "specification section reference graphic",
  "speed FPM",
  "spiral length",
  "splice length",
  "split line offset",
  "spot coordinate",
  "spot easting northing",
  "spot elevation",
  "spot grade",
  "spot grade callout graphic",
  "spot slope",
  "sprinkler count",
  "sprinkler design density",
  "sprinkler head tag",
  "sprinkler schedule",
  "sprinkler schedule on sheet",
  "sprinkler spacing dimension",
  "sprinkler type legend",
  "square feet",
  "stair elevation marker",
  "stair identification sign",
  "stair section callout",
  "stair section marker",
  "stair tag",
  "stair width",
  "standpipe connection tag",
  "standpipe residual pressure",
  "standpipe tag",
  "state plane zone note",
  "static pressure",
  "station along alignment",
  "station equation",
  "STC assembly rating",
  "steam pressure note",
  "steel grade callout",
  "step height",
  "stock length",
  "stormwater tributary area",
  "story height",
  "straightness tolerance",
  "striping legend",
  "structural beam tag",
  "structural brace tag",
  "structural column tag",
  "structural grid label",
  "structural section marker",
  "structural steel legend",
  "structural top of steel",
  "stud count",
  "stud leg length",
  "subbase thickness",
  "subgrade elevation",
  "submittal reference",
  "substantial completion marker",
  "sump depth",
  "sump discharge GPM",
  "supply airflow CFM",
  "surface area",
  "survey base point note",
  "survey benchmark callout",
  "survey elevation",
  "survey legend",
  "survey reference",
  "swale depth",
  "sweep angle",
  "switch tag",
  "SWPPP reference",
  "symbol legend",
  "system abbreviation tag",
  "tangent length",
  "TBD flag",
  "TBD note",
  "TBD tag",
  "TDD symbol",
  "temporary support note",
  "test pressure",
  "test report reference",
  "thermal imaging note",
  "thermal performance value",
  "throat dimension",
  "tilt-up panel mark",
  "title block",
  "toe board height",
  "toilet clearance diagram",
  "tolerance",
  "tonnage steel",
  "top of blocking",
  "top of concrete",
  "top of concrete marker",
  "top of deck",
  "top of deck marker",
  "top of footing",
  "top of steel marker",
  "top of wall",
  "top of wall framing",
  "topping thickness",
  "total airflow CFM",
  "total rise",
  "total wall assembly thickness",
  "traffic sign legend",
  "transformer tag",
  "travel distance annotation",
  "tread depth",
  "tree protection zone",
  "tree tag",
  "trench depth",
  "trench width",
  "tributary seismic weight",
  "trip setting note",
  "true length vs projected length",
  "true north to project north angle",
  "true north to project north note",
  "turning radius diagram",
  "typical note",
  "U-factor callout",
  "UL assembly listing reference",
  "UL assembly listing reference graphic",
  "underlay",
  "underlay ghost graphic",
  "underside of deck",
  "underside of deck marker",
  "unfactored load note",
  "uniform load",
  "usable area",
  "utility elevation marker",
  "utility legend",
  "utility line label",
  "utility pole tag",
  "valve schedule",
  "valve schedule on sheet",
  "valve tag",
  "valve tag number",
  "valve type legend",
  "vapor permeance note",
  "velocity pressure",
  "veneer thickness",
  "vertical curve K-value",
  "vertical curve length",
  "vertical rise",
  "view depth",
  "view range graphic",
  "view reference bubble",
  "view title",
  "visual alarm symbol",
  "VOC note",
  "volt-amperes",
  "voltage",
  "voltage drop note",
  "volume",
  "VT callout",
  "wall area",
  "wall fire rating annotation",
  "wall section callout",
  "wall section marker",
  "wall tag",
  "wall type legend",
  "wall type section marker",
  "wall type tag",
  "warning line offset",
  "warranty note",
  "water supply fixture units note",
  "water use intensity note",
  "waterproofing area",
  "waterproofing build-up thickness",
  "waterproofing note",
  "wattage",
  "web thickness",
  "weld count",
  "weld length",
  "weld mark",
  "weld symbol reference",
  "weld tolerance",
  "wetland boundary label",
  "wind load",
  "wind load design pressure on cladding",
  "window schedule",
  "window schedule on sheet",
  "window tag",
  "window type legend",
  "window type mark",
  "wire size",
  "work plane graphic",
  "work plane offset",
  "work plane tag",
  "work point offset",
  "workset responsibility note",
  "workset tint",
  "workset tint legend"
];

/** Counts verified at generation time — full taxonomy, no truncation. */
export const TAXONOMY_STATS = {
  "referenceGroupCount": 17,
  "dimensionalGroupCount": 25,
  "referenceKindCount": 439,
  "dimensionalKindCount": 586,
  "uniqueKindCount": 985,
  "sourceFiles": [
    "backend/utils/Daydream/AECOReferenceAnnotations.mjs",
    "backend/utils/Daydream/AECODimensionalOutputs.mjs"
  ]
};

export const DIMENSIONAL_OUTPUT_KINDS_LC = new Set(ALL_DIMENSIONAL_OUTPUT_KINDS.map((k) => k.toLowerCase()));

export const REFERENCE_ANNOTATION_KINDS_LC = new Set(ALL_REFERENCE_ANNOTATION_KINDS.map((k) => k.toLowerCase()));
